import { ErrorLike } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import { STACK_ROLE_BINDINGS_WITH_ROLES, StackRoleBindingsData } from "./gql";
import { StackRoleBindingView } from "./types";

type UseStackRoleBindingsProps = {
  stackID: string;
};

type UseStackRoleBindingsReturn = {
  stackRoleBindings: StackRoleBindingView[];
  roles: Array<{ id: string; name: string }>;
  loading: boolean;
  hasData: boolean;
  error: ErrorLike | undefined;
  refetch: useQuery.Result<StackRoleBindingsData>["refetch"];
};

const useStackRoleBindings = ({
  stackID,
}: UseStackRoleBindingsProps): UseStackRoleBindingsReturn => {
  const { data, loading, error, refetch } = useQuery(STACK_ROLE_BINDINGS_WITH_ROLES, {
    variables: {
      id: stackID,
    },
  });

  return {
    stackRoleBindings: data?.stack?.roleBindings || [],
    roles: data?.roles || [],
    loading,
    hasData: !!data?.stack?.roleBindings,
    error,
    refetch,
  };
};

export default useStackRoleBindings;
